import { render, staticRenderFns } from "./form.vue?vue&type=template&id=7a70f639"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a70f639')) {
      api.createRecord('7a70f639', component.options)
    } else {
      api.reload('7a70f639', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=7a70f639", function () {
      api.rerender('7a70f639', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/furlough/form.vue"
export default component.exports